export const PRO_PRICE = 349.99;
